import { Button, Col, Row, Space } from "antd";
import { FC, useCallback, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

export interface PositionDataButtonsParams {
  tNS: string;
  tPrefix: string;

  canAddDefaultPositionData: boolean;
  canGetPositionData: boolean;
  canMirrorPositionData: boolean;
  canDeletePositionData: boolean;

  addDefaultPositionData(): void;

  getPositionData(absolute: boolean): void;

  mirrorPositionData(): void;

  deletePositionData(): void;
}

export const PositionDataButtons: FC<PositionDataButtonsParams> = (
  {
    tNS, tPrefix,
    addDefaultPositionData,
    getPositionData,
    mirrorPositionData,
    deletePositionData,
    ...status
  },
) => {
  useTranslation();

  // spacing between columns (horizontal)
  const gutterSize = useMemo(() => 8, []);

  const getRelativePositionData = useCallback(() => getPositionData(false), [getPositionData]);
  const getAbsolutePositionData = useCallback(() => getPositionData(true), [getPositionData]);

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Row gutter={gutterSize}>
        <Col span={12}>
          <Button block type="primary" disabled={!status.canAddDefaultPositionData} onClick={addDefaultPositionData}>
            <Trans ns={tNS} i18nKey={tPrefix + "button.add"}/>
          </Button>
        </Col>
        <Col span={12}>
          <Button block type="primary" disabled={!status.canGetPositionData} onClick={getRelativePositionData}>
            <Trans ns={tNS} i18nKey={tPrefix + "button.getRelative"}/>
          </Button>
        </Col>
      </Row>
      <Row gutter={gutterSize}>
        <Col span={24}>
          <Button block type="primary" disabled={!status.canGetPositionData} onClick={getAbsolutePositionData}>
            <Trans ns={tNS} i18nKey={tPrefix + "button.getAbsolute"}/>
          </Button>
        </Col>
      </Row>
      <Row gutter={gutterSize}>
        <Col span={24}>
          <Button block type="primary" disabled={!status.canMirrorPositionData} onClick={mirrorPositionData}>
            <Trans ns={tNS} i18nKey={tPrefix + "button.mirror"}/>
          </Button>
        </Col>
      </Row>
      <Row gutter={gutterSize}>
        <Col span={24}>
          <Button block type="primary" disabled={!status.canDeletePositionData} onClick={deletePositionData}>
            <Trans ns={tNS} i18nKey={tPrefix + "button.delete"}/>
          </Button>
        </Col>
      </Row>
    </Space>
  );
};
